<template>
  <div class="vh-flex">
    
    <SimpleOptionSelectorField class="ops-item" @itemClick="errorSoundChange" name="错误音效" :curkey="errorKey" :options="errorOptions"></SimpleOptionSelectorField>
    <SimpleOptionSelectorField class="ops-item" @itemClick="correctSoundChange" name="正确音效" :curkey="correctKey" :options="correctOptions"></SimpleOptionSelectorField>
    <SimpleOptionSelectorField class="ops-item" @itemClick="keyboardSoundChange" name="按键音效" :curkey="keyboardKey" :options="keyboardOptions"></SimpleOptionSelectorField>
  </div>
</template>

<script>
import SimpleOptionSelectorField from '@/components/SimpleOptionSelectorField.vue';
import spellConfig from '@/commom/config/SpellConfig'
export default {
  name: 'SoundEffectConfig',
  components: {
    SimpleOptionSelectorField
  },
  props: {
    
  },
  data(){
    return {
        config:null,
        keyboardKey:"",
        ///错误音效
        errorKey:"",
        ///正确音效
        correctKey:"",
        keyboardOptions:[
            {name:"关闭",key:""},
            {name:"按键音1",key:"keyboard.wav"},
            {name:"按键音2",key:"keyboard1.mp3"},
            {name:"按键音3",key:"keyboard2.mp3"},
            {name:"按键音4",key:"keyboard3.mp3"},
            {name:"按键音5",key:"keyboard4.mp3"},
            {name:"按键音6",key:"keyboard8.mp3"}
        ],
        ///错误音效
        errorOptions:[
            {name:"关闭",key:""},
            {name:"错误音1",key:"error.wav"},
        ],
        ///正确音效
        correctOptions:[
            {name:"关闭",key:""},
            {name:"正确音1",key:"correct.wav"},
        ],
        
    }
  },
  ///挂载完成
  mounted:function(){
    this.config = spellConfig.getConfig()
    this.keyboardKey = this.config.soundEffect.keyboard
    this.errorKey = this.config.soundEffect.error
    this.correctKey = this.config.soundEffect.correct

  },
  methods:{
    ///自动播放改变
    keyboardSoundChange:function(ops){
      this.keyboardKey = ops.key
      this.config.soundEffect.keyboard = ops.key
      spellConfig.saveConfig()
      ///播放音效
      if(ops.key!=""){
        this.playSoundEffect(ops.key)
      }
    },
    ///错误音效改变
    errorSoundChange:function(ops){
      this.errorKey = ops.key
      this.config.soundEffect.error = ops.key
      spellConfig.saveConfig()
      ///播放音效
      if(ops.key!=""){
        this.playSoundEffect(ops.key)
      }
    },
    ///正确音效改变
    correctSoundChange:function(ops){
      this.correctKey = ops.key
      this.config.soundEffect.correct = ops.key
      spellConfig.saveConfig()
      ///播放音效
      if(ops.key!=""){
        this.playSoundEffect(ops.key)
      }
    },
    ///播放音效
    playSoundEffect:function(soundKey){
      var audio = new Audio()
      audio.src = `./sound/${soundKey}`
      audio.play()
    }

  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ops-item{
    margin-bottom: 15px;
}
</style>
